module.exports = __webpack_public_path__ + "static/media/ic_robotrader_about_three.0006633a.svg";